import "./spinner.css";

export const Spinner = ({ size }: { size?: number }) => (
  <div className="loader" style={{ width: size, height: size }}></div>
)
